<template>
  <section class="frame-container">
    <aside class="aside">
      <Search></Search>
    </aside>
    <section class="main-container">
      <Header class="header"></Header>
      <main class="main">
        <router-view></router-view>
      </main>
      <footer class="footer"> </footer>
    </section>
  </section>
</template>

<script>
import Search from '@/components/Search'
import Header from '@/components/Header'

export default {
  components: {
    Search,
    Header,
  },
}
</script>

<style lang="scss">
.frame-container {
  width: 100%;
  height: 100%;
  display: flex;
  &.vertical {
    flex-direction: column;
  }
  .aside {
    min-width: 450px;
    background: #fafafa;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 5px;
    box-shadow: 0px 2px 5px #ccc;
    flex: 1;
    padding: 10px;
    text-align: left;
  }
  .main-container {
    flex: 99;
    max-width: 1940px;
    overflow: auto;
    overflow-y: scroll;
  }
  .header {
  }
  .main {
  }
  .footer {
  }
}
</style>
